<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Explore, Learn, and Grow with ARNI</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Blog detail</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="blog-details-area ptb-110">
    <div class="container">
        <div class="row">
            <div class="col-lg-2">
            </div>
            <div class="col-lg-8 col-md-12">
                <div class="blog-details">
                    <div class="article-image">
                        <img src="{{selectedData?.blog_banner.url}}" alt="image">
                    </div>
                    <div class="article-content">
                        <h3>{{ selectedData?.heading }}</h3>
                        <span [innerHTML]="selectedData?.content" style="text-align: justify;"></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-2">
            </div>
        </div>
    </div>
</section>
